import axiosClient from "./axiosClient";

export const UserType = {
  User: 1,
  BusinessOwner: 2,
  Delivery: 3,
  Admin: 4,
  DeliveryCompany: 5,
};

export async function login(email, password) {
  const response = await axiosClient.post("/Users/login", {
    email,
    password,
  });
  return response.data;
}

export async function guestLogin(deviceId) {
  const response = await axiosClient.post("/Users/guest-login", { deviceId });
  return response.data;
}

// `country` picks the SMS provider on the backend: IL -> SMS4Free, PS -> TweetSMS.
export async function sendClientOtp(phone, country) {
  const response = await axiosClient.post("/Users/otp/send", { phone, country });
  return response.data;
}

export async function verifyClientOtp(phone, code) {
  const response = await axiosClient.post("/Users/otp/verify", { phone, code });
  return response.data;
}

// Development-only: backend rejects this outside Development (or AllowDevLogin).
export async function devLoginClient() {
  const response = await axiosClient.post("/Users/dev-login");
  return response.data;
}
